<template>
  <div>
    <div class="source">
      <el-row class="querypanel">
        <el-col :span="6">
          <div class="leftpanel">
          <div>客户用户组列表:</div> <br/>
          <el-tree
            class="filter-tree"
            :data="usergroupsdata"
            :props="defaultProps"
            default-expand-all
            :expand-on-click-node="false"
            :render-content="renderugcontext">
          </el-tree>
          <div class="desinfo"> *可以把集团子公司或公司内部门作为不同的用户组</div>
        </div>
        </el-col>
        <el-col :span="18">
          <div class="rightpanel">
            <el-collapse v-model="activeNames" accordion >
              <el-collapse-item title="公司部门总称" name="0">
                <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                  <el-form-item label="公司部门总称">
                    <el-input v-model="gsbminfo"></el-input>
                  </el-form-item>
                  <el-form-item label="新增一级部门名称">
                    <el-input v-model="nameone" placeholder="仅新增一级子部门时添加"></el-input>
                  </el-form-item>
                    <el-button @click="addzero">新增公司部门总称</el-button>
                    <el-button @click="changezero">修改并保存</el-button>
                    <el-button @click="addone">新增一级子单位/部门</el-button>
                </el-form>
              </el-collapse-item>
              <el-collapse-item title="一级单位（部门）" name="1">
                <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                  <el-form-item label="当前一级单位（部门）">
                    <el-input v-model="gsbmone"></el-input>
                  </el-form-item>
                  <el-form-item label="新增二级部门名称">
                    <el-input v-model="nametwo" placeholder="仅新增二级子部门时添加"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="changeone">修改并保存</el-button>
                    <el-button @click="addtwo">新增二级单位/部门</el-button>
                  </el-form-item>
                </el-form>
              </el-collapse-item>
              <el-collapse-item title="二级单位（部门）" name="2">
                <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                  <el-form-item label="当前二级单位（部门）">
                    <el-input v-model="gsbmtwo"></el-input>
                  </el-form-item>
                  <el-form-item label="新增三级部门名称">
                    <el-input v-model="namethree" placeholder="仅新增三级子部门时添加"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="changetwo">修改并保存</el-button>
                    <el-button @click="addthree">新增三级单位/部门</el-button>
                  </el-form-item>
                  <div>

                  </div>
                </el-form>
              </el-collapse-item>
              <el-collapse-item title="三级单位（部门）" name="3">
                <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                  <el-form-item label="当前三级单位（部门）">
                    <el-input v-model="gsbmthree"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="changethree">修改并保存</el-button>
                  </el-form-item>
                </el-form>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import { Loading } from 'element-ui'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'CusUsersGroups',
  beforeCreate: function () {
    that = this
    console.log('开始创建')
  },
  mounted: function () {
    let loadingInstance1 = Loading.service({ fullscreen: true })
    var menudata = this.$parent.$children[1].$refs.menu_data
    console.log(menudata)
    menudata.activeIndex = '113'
    var v = getCookie('cusid')
    this.khid = v
    if (that.khid === null) {
      loadingInstance1.close()
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      if (v === '1') {
        this.showcuslist = false
        loadingInstance1.close()
        that.$http({
          url: 'https://api.sqnetsoft.cn/customer/getusergrouptree',
          method: 'post',
          data: {
            cusid: parseInt(v),
            parentid: -1
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            loadingInstance1.close()
            console.log(res)
            console.log(JSON.parse(res.data.data))
            if (res.data.success) {
              that.usergroupsdata = JSON.parse(res.data.data)
              that.treereccount = JSON.parse(res.data.data).length
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      } else {
        this.showcuslist = true
        that.$http({
          url: 'https://api.sqnetsoft.cn/customer/getusergrouptree',
          method: 'post',
          data: {
            cusid: parseInt(v),
            parentid: -1
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            loadingInstance1.close()
            console.log(res)
            console.log(JSON.parse(res.data.data))
            if (res.data.success) {
              that.usergroupsdata = JSON.parse(res.data.data)
              that.treereccount = JSON.parse(res.data.data).length
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    }
    console.log(this.showcuslist)
  },
  data () {
    return {
      usergroupsdata: [],
      showcuslist: true,
      query_cusdata: [],
      query_ug_cusname: '',
      khid: '',
      activeNames: [],
      query_ug_cusno: '',
      selectnode: [],
      gsbminfo: '',
      nameone: '',
      nametwo: '',
      namethree: '',
      gsbmone: '',
      gsbmtwo: '',
      gsbmthree: '',
      treereccount: 0,
      defaultProps: {
        children: 'Children',
        label: 'Name'
      }
    }
  },
  methods: {
    tusergroupclick (data) {
      console.log(data)
    },
    renderugcontext (h, { node, data, store }) {
      return (
        <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
          <span>
            <span>{data.Name}</span>
          </span>
          <span>
            <i class="fa fa-pencil-square-o opicon" on-click={ () => this.edit(node, data)}> </i>
            <i class="fa fa-trash-o opicon" on-click={ () => this.remove(node, data)}> </i>
          </span>
        </span>
      )
    },
    querycus: function () {
      let loadingInstance1 = Loading.service({ fullscreen: true })
      console.log(this.query_ug_cusname)
      console.log(this.query_ug_cusno)
      var qstr = 'ownerid =' + this.khid
      if (this.query_ug_cusname !== null && this.query_ug_cusname !== '') {
        qstr = qstr + " and name like '%" + this.query_ug_cusname + "%' "
      }
      if (this.query_ug_cusno !== null && this.query_ug_cusno !== '') {
        qstr = qstr + " and bl_num like '%" + this.query_ug_cusno + "%'"
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/getcus',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          limit: {String: 'limit 2', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          loadingInstance1.close()
          console.log(res)
          console.log(JSON.parse(res.data.data))
          if (res.data.success) {
            that.query_cusdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    seeusergroup (row) {
      let loadingInstance1 = Loading.service({ fullscreen: true })
      console.log(row.id)
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/getusergrouptree',
        method: 'post',
        data: {
          cusid: parseInt(row.id),
          parentid: -1
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          console.log(JSON.parse(res.data.data))
          if (res.data.success) {
            loadingInstance1.close()
            that.usergroupsdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    edit (node, data) {
      console.log(node)
      console.log(data.Level)
      this.nameone = ''
      this.nametwo = ''
      this.namethree = ''
      this.selectnode = data
      this.activeNames = [data.Level.toString()]
      switch (data.Level) {
        case 0: {
          this.gsbminfo = data.Name
          break
        }
        case 1: {
          this.gsbmone = data.Name
          break
        }
        case 2: {
          this.gsbmtwo = data.Name
          break
        }
        case 3: {
          this.gsbmthree = data.Name
          break
        }
      }
    },
    remove (node, data) {
      let loadingInstance1 = Loading.service({ fullscreen: true })
      console.log(node)
      console.log(data)
      var idlist = []
      if (data.HasChild === 0) {
        idlist.push(data.Id)
      } else {
        idlist.push(data.Id)
        var cnode = data.Children
        for (var index in cnode) {
          console.log(cnode[index])
          idlist.push(cnode[index].Id)
          if (cnode[index].HasChild === 0) {
          } else {
            var cinode = cnode[index].Children
            for (var i in cinode) {
              idlist.push(cinode[i].Id)
              if (cinode[i].HasChild === 0) {
              } else {
                var ciinode = cinode[i].Children
                for (var j in ciinode.Children) {
                  idlist.push(ciinode.Children[j].Id)
                  if (cinode[i].HasChild === 0) {
                  } else {
                    for (var k in ciinode.Children) {
                      idlist.push(ciinode.Children[k].Id)
                    }
                  }
                }
              }
            }
          }
        }
      }
      console.log(idlist)
      var idstr = 'id in (' + idlist + ')'
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/delcususergroups',
        method: 'post',
        data: {
          whereinfo: {String: idstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            if (res.data.success) {
              that.$http({
                url: 'https://api.sqnetsoft.cn/customer/getusergrouptree',
                method: 'post',
                data: {
                  cusid: parseInt(that.khid),
                  parentid: -1
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  loadingInstance1.close()
                  that.usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    changezero () {
      let loadingInstance1 = Loading.service({ fullscreen: true })
      console.log(this.selectnode)
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/addcususergroups',
        method: 'post',
        data: {
          id: {Int64: parseInt(this.selectnode.Id), Valid: true},
          cusid: parseInt(this.khid),
          name: {String: this.gsbminfo, Valid: true},
          level: parseInt(this.selectnode.Level),
          haschild: parseInt(this.selectnode.HasChild),
          parentid: parseInt(this.selectnode.ParentID)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/customer/getusergrouptree',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  loadingInstance1.close()
                  that.usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    addzero () {
      let loadingInstance1 = Loading.service({ fullscreen: true })
      if (that.treereccount <= 0) {
        that.$http({
          url: 'https://api.sqnetsoft.cn/customer/addcususergroups',
          method: 'post',
          data: {
            cusid: parseInt(this.khid),
            name: {String: this.gsbminfo, Valid: true},
            level: parseInt(0),
            haschild: parseInt(0),
            parentid: parseInt(-1)
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$http({
                url: 'https://api.sqnetsoft.cn/customer/getusergrouptree',
                method: 'post',
                data: {
                  cusid: parseInt(this.khid),
                  parentid: -1
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    loadingInstance1.close()
                    that.$message({
                      type: 'success',
                      message: '添加成功!'
                    })
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      } else {
        loadingInstance1.close()
        that.$message({
          type: 'error',
          message: '只能保留一个部门总称!'
        })
      }
    },
    changeone () {
      let loadingInstance1 = Loading.service({ fullscreen: true })
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/addcususergroups',
        method: 'post',
        data: {
          id: {Int64: parseInt(this.selectnode.Id), Valid: true},
          cusid: parseInt(this.khid),
          name: {String: this.gsbmone, Valid: true},
          level: parseInt(this.selectnode.Level),
          haschild: parseInt(this.selectnode.HasChild),
          parentid: parseInt(this.selectnode.ParentID)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/customer/getusergrouptree',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  loadingInstance1.close()
                  that.usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    changetwo () {
      let loadingInstance1 = Loading.service({ fullscreen: true })
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/addcususergroups',
        method: 'post',
        data: {
          id: {Int64: parseInt(this.selectnode.Id), Valid: true},
          cusid: parseInt(this.khid),
          name: {String: this.gsbmtwo, Valid: true},
          level: parseInt(this.selectnode.Level),
          haschild: parseInt(that.selectnode.HasChild),
          parentid: parseInt(that.selectnode.ParentID)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/customer/getusergrouptree',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  loadingInstance1.close()
                  that.usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    changethree () {
      let loadingInstance1 = Loading.service({ fullscreen: true })
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/addcususergroups',
        method: 'post',
        data: {
          id: {Int64: parseInt(that.selectnode.Id), Valid: true},
          cusid: parseInt(that.khid),
          name: {String: that.gsbmthree, Valid: true},
          level: parseInt(that.selectnode.Level),
          haschild: parseInt(that.selectnode.HasChild),
          parentid: parseInt(that.selectnode.ParentID)
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/customer/getusergrouptree',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  loadingInstance1.close()
                  that.usergroupsdata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    addone () {
      let loadingInstance1 = Loading.service({ fullscreen: true })
      console.log(this.selectnode)
      var newnode = []
      var oldobj = {
        id: {Int64: parseInt(this.selectnode.Id), Valid: true},
        cusid: parseInt(this.khid),
        name: {String: this.gsbminfo, Valid: true},
        level: parseInt(this.selectnode.Level),
        haschild: parseInt(1),
        parentid: parseInt(this.selectnode.ParentID)
      }
      var newobj = {
        cusid: parseInt(this.khid),
        name: {String: this.nameone, Valid: true},
        level: parseInt(this.selectnode.Level) + 1,
        haschild: parseInt(0),
        parentid: parseInt(this.selectnode.Id)
      }
      newnode.push(oldobj)
      newnode.push(newobj)
      console.log(newnode)
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/paddcususergroups',
        method: 'post',
        data: newnode,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/customer/getusergrouptree',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                loadingInstance1.close()
                that.usergroupsdata = JSON.parse(res.data.data)
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    addtwo () {
      let loadingInstance1 = Loading.service({ fullscreen: true })
      console.log(this.selectnode)
      var newnode = []
      var oldobj = {
        id: {Int64: parseInt(this.selectnode.Id), Valid: true},
        cusid: parseInt(this.khid),
        name: {String: this.gsbmone, Valid: true},
        level: parseInt(this.selectnode.Level),
        haschild: parseInt(1),
        parentid: parseInt(this.selectnode.ParentID)
      }
      var newobj = {
        cusid: parseInt(this.khid),
        name: {String: this.nametwo, Valid: true},
        level: parseInt(this.selectnode.Level) + 1,
        haschild: parseInt(0),
        parentid: parseInt(this.selectnode.Id)
      }
      newnode.push(oldobj)
      newnode.push(newobj)
      console.log(newnode)
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/paddcususergroups',
        method: 'post',
        data: newnode,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/customer/getusergrouptree',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                loadingInstance1.close()
                that.usergroupsdata = JSON.parse(res.data.data)
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    addthree () {
      let loadingInstance1 = Loading.service({ fullscreen: true })
      console.log(this.selectnode)
      var newnode = []
      var oldobj = {
        id: {Int64: parseInt(this.selectnode.Id), Valid: true},
        cusid: parseInt(this.khid),
        name: {String: this.gsbmtwo, Valid: true},
        level: parseInt(this.selectnode.Level),
        haschild: parseInt(1),
        parentid: parseInt(this.selectnode.ParentID)
      }
      var newobj = {
        cusid: parseInt(this.khid),
        name: {String: this.namethree, Valid: true},
        level: parseInt(this.selectnode.Level) + 1,
        haschild: parseInt(0),
        parentid: parseInt(this.selectnode.Id)
      }
      newnode.push(oldobj)
      newnode.push(newobj)
      console.log(newnode)
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/paddcususergroups',
        method: 'post',
        data: newnode,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/customer/getusergrouptree',
              method: 'post',
              data: {
                cusid: parseInt(that.khid),
                parentid: -1
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                loadingInstance1.close()
                that.usergroupsdata = JSON.parse(res.data.data)
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/cus/CusUsersGroup.vue